"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BarChart = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var core_1 = require("@material-ui/core");
var bar_1 = require("@nivo/bar");
var classnames_1 = __importDefault(require("classnames"));
var lodash_1 = require("lodash");
var chartHooks_1 = require("../../../hooks/charts/chartHooks");
var theme_1 = __importDefault(require("../../../styles/theme"));
var objectUtilities_1 = require("../../../util/objectUtilities");
var Skeleton_1 = require("../../atoms/Skeleton/Skeleton");
var BarChart_style_1 = __importDefault(require("./BarChart.style"));
/**
 * BarChart molecule
 *
 * {@link https://stories.data.bmw.cloud/?path=/docs/molecules-barchart--bound-story Docs}
 * {@link https://github.com/bmw-cdh/cdh-data-portal-theme/tree/main/components/molecules/BarChart Source}
 */
var BarChart = function (_a) {
    var className = _a.className, data = _a.data, _b = _a.enableLabel, enableLabel = _b === void 0 ? true : _b, footnote = _a.footnote, gridProps = _a.gridProps, _c = _a.loading, loading = _c === void 0 ? false : _c, _d = _a.logarithmic, logarithmic = _d === void 0 ? false : _d, _e = _a.numberOfYTicks, numberOfYTicks = _e === void 0 ? 6 : _e, _f = _a.showAxisLeft, showAxisLeft = _f === void 0 ? true : _f, _g = _a.showLegend, showLegend = _g === void 0 ? false : _g, title = _a.title, xLabel = _a.xLabel, yAxisFormatter = _a.yAxisFormatter, yFormatter = _a.yFormatter, yLabel = _a.yLabel;
    var classes = (0, BarChart_style_1.default)();
    var colors = (0, lodash_1.values)(theme_1.default.chartColors);
    var barData = (0, objectUtilities_1.filterMap)(data, function (datum) { return ((0, lodash_1.some)(datum, function (value) { return (0, lodash_1.isNil)(value); }) ? null : datum); });
    var _h = (0, chartHooks_1.useBarLogScale)(barData, numberOfYTicks), log = _h.log, exp = _h.exp;
    var effectiveYFormatter = yAxisFormatter || yFormatter;
    if ((0, lodash_1.isEmpty)(barData) && !loading) {
        return null;
    }
    return ((0, jsx_runtime_1.jsxs)(core_1.Grid, __assign({ item: true }, gridProps, { children: [(0, jsx_runtime_1.jsx)(core_1.ListSubheader, __assign({ disableGutters: true, disableSticky: true, className: (0, classnames_1.default)(className, classes.textAlignCenter) }, { children: title })), renderBars(), footnote] })));
    function renderBars() {
        if (loading) {
            return ((0, jsx_runtime_1.jsxs)("div", __assign({ className: (0, classnames_1.default)(classes.chartContainer, classes.loadingContainer) }, { children: [renderSkeletonBar(), renderSkeletonBar(), renderSkeletonBar()] })));
        }
        return ((0, jsx_runtime_1.jsx)("div", __assign({ className: classes.chartContainer }, { children: (0, jsx_runtime_1.jsx)(bar_1.ResponsiveBar, { data: logarithmic
                    ? (0, lodash_1.map)(barData, function (datum) { return (__assign(__assign({}, datum), { value: log(datum.value) })); })
                    : barData, keys: ['value'], indexBy: 'id', margin: { top: 20, right: showLegend ? 160 : 40, bottom: 50, left: 40 }, padding: 0.3, colors: function (_a) {
                    var index = _a.index;
                    return colors[index % colors.length];
                }, borderColor: { from: 'color', modifiers: [['darker', 1.6]] }, axisBottom: {
                    tickSize: 5,
                    tickPadding: 5,
                    tickRotation: 0,
                    legend: xLabel,
                    legendPosition: 'middle',
                    legendOffset: 32,
                }, axisLeft: showAxisLeft
                    ? {
                        format: function (value) { return effectiveYFormatter(logarithmic ? exp(value) : value); },
                        tickSize: 0,
                        tickPadding: 5,
                        tickRotation: 0,
                        tickValues: numberOfYTicks,
                        legend: yLabel,
                        legendPosition: 'middle',
                        legendOffset: -40,
                    }
                    : undefined, tooltip: function (_a) {
                    var value = _a.value, color = _a.color, indexValue = _a.indexValue;
                    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(core_1.Typography, __assign({ gutterBottom: true, variant: 'body2', className: classes.bold }, { children: indexValue })), (0, jsx_runtime_1.jsxs)(core_1.Typography, __assign({ variant: 'body2', className: classes.bold }, { children: [(0, jsx_runtime_1.jsx)("span", { className: classes.colorBox, style: { background: color } }), yFormatter(logarithmic ? exp(value) : value)] }))] }));
                }, enableLabel: enableLabel, label: function (_a) {
                    var value = _a.value;
                    return (value !== null ? effectiveYFormatter(logarithmic ? exp(value) : value) : '');
                }, labelSkipWidth: 12, labelSkipHeight: 12, labelTextColor: { from: 'color', modifiers: [['darker', 3]] }, legends: showLegend
                    ? [
                        {
                            dataFrom: 'indexes',
                            anchor: 'bottom-right',
                            direction: 'column',
                            justify: false,
                            translateX: 120,
                            translateY: 0,
                            itemsSpacing: 2,
                            itemWidth: 100,
                            itemHeight: 20,
                            itemDirection: 'left-to-right',
                            itemOpacity: 0.85,
                            symbolSize: 20,
                            effects: [
                                {
                                    on: 'hover',
                                    style: {
                                        itemOpacity: 1,
                                    },
                                },
                            ],
                        },
                    ]
                    : undefined, animate: true }) })));
    }
    function renderSkeletonBar() {
        return (0, jsx_runtime_1.jsx)(Skeleton_1.Skeleton, { width: '20%', height: "".concat((0, lodash_1.random)(20, 100), "%"), className: classes.skeletonBar });
    }
};
exports.BarChart = BarChart;
